<template>
    <div
        v-if="url"
        :style="type === TYPES.BACKGROUND ? { ...styles } : ''"
        :class="classes"
    >
        <img v-if="type === TYPES.IMAGE" :src="this.url" :alt="alt">
    </div>
</template>

<script>
const TYPES = {
  BACKGROUND: 'background',
  IMAGE: 'image',
};

export default {
  name: 'BaseImage',
  data() {
    return {
      TYPES,
      styles: {
        height: this.height ? `${this.height}rem` : '',
        width: this.width ? `${this.width}rem` : '',
        backgroundImage: `url(${this.url})`,
        backgroundSize: this.size,
        backgroundPosition: this.position,
        backgroundRepeat: this.repeat,
      },
    };
  },
  computed: {
    classes() {
      return {
        'base-image': true,
        'base-image--fill': this.fill,
      };
    },
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      validator(val) {
        return Object.values(TYPES).indexOf(val) !== -1;
      },
    },
    height: {
      type: [Number, String],
      default: 10,
    },
    width: {
      type: [Number, String],
      default: '',
    },
    fill: Boolean,
    size: {
      type: String,
      default: 'cover',
    },
    position: {
      type: String,
      default: 'center center',
    },
    repeat: {
      type: String,
      default: 'no-repeat',
    },
  },
};
</script>

<style lang="scss" scoped>
.base-image {
    &--fill img {
        width: 100%;
    }
}
</style>
